import React from 'react';
import '../styles/Home.css';
import Hero from '../components/Hero';
import Services from '../components/Service';
import FloatingHelpButton from '../components/FloatingHelpButton';
import Gallery from '../components/Gallery';

function Home() {
  return (
    <div>
      <Hero/>
      <Gallery />
      <Services />
      <FloatingHelpButton />
    </div>
  );
}

export default Home;